import { toCtaData } from "@/contents/converters/atoms"
import { toLink } from "@/contents/converters/links"
import BlokWrapper from "@/contents/integrations/BlokWrapper"
import { SanityDecoration } from "@/contents/molecules/SanityDecoration"
import { ItemsList } from "@/contents/sanityTypes"
import SanityImageField from "@/integrations/sanity/components/SanityImageField"
import SanityRichTextField from "@/integrations/sanity/components/SanityRichTextField"
import ItemsListBlock from "@/ui/organisms/ItemsListBlock"
import { ShapeRounding } from "@/ui/types/rounding"

export interface SanityItemsListProps {
  content: ItemsList
}

const SanityItemsList = ({ content }: SanityItemsListProps) => {
  return (
    <BlokWrapper contents={content} menuColor="dark">
      <ItemsListBlock
        container={content.container?.type}
        color={content.color}
        alignment={content.alignment}
        title={<SanityRichTextField value={content.title} />}
        gridLayout={{
          columns: content.gridLayout?.columns ?? {},
          gap: content.gridLayout?.gap ?? {},
        }}
        listType={content.listType ?? "grid"}
        textPadding={content.textPadding}
        imageTopMargin={content.imageTopMargin}
        items={
          content.items?.map((x) => ({
            image: x.image?.image?.asset ? (
              <SanityImageField asset={x.image?.image?.asset} fill="width" />
            ) : undefined,
            title: <SanityRichTextField value={x.title} />,
            subtitle: <SanityRichTextField value={x.subtitle} />,
            caption: <SanityRichTextField value={x.caption} />,
            decoration: x.image?.decoration?.image?.asset ? (
              <SanityDecoration
                asset={x.image.decoration.image.asset}
                position={x.image.decoration.position ?? {}}
                size={x.image.decoration.size ?? {}}
                absolute
              />
            ) : undefined,
            rounding: (x.image?.rounding ?? {}) as ShapeRounding,
            link: toLink(x.link),
          })) ?? []
        }
        itemContainer={content.itemContainer}
        cta={
          content.ctaList?.items
            ? {
                items: content.ctaList.items
                  .map((cta) => toCtaData(cta)!)
                  .filter((x) => x),
                direction: content.ctaList.direction,
              }
            : undefined
        }
        decorations={[
          ...(content.decoration?.image?.asset
            ? [
                <SanityDecoration
                  key={1}
                  asset={content.decoration.image.asset}
                  position={content.decoration.position ?? {}}
                  size={content.decoration.size ?? {}}
                  absolute
                />,
              ]
            : []),
          ...(content.decoration2?.image?.asset
            ? [
                <SanityDecoration
                  key={1}
                  asset={content.decoration2.image.asset}
                  position={content.decoration2.position ?? {}}
                  size={content.decoration2.size ?? {}}
                  absolute
                />,
              ]
            : []),
        ]}
      />
    </BlokWrapper>
  )
}

export default SanityItemsList
